import gsap from 'gsap';

import { Graphics } from 'pixi.js';
import { MonoBehavior } from './core/monoBehavior';
import { Power1 } from 'gsap';
import { Card } from 'components/Card';
import { MOVE_Z_INDEX } from 'constants/layout';

export class MagicOverlay extends MonoBehavior {
    overlay: Graphics;

    constructor(card: Card) {
        super();
        this.overlay = new Graphics();
        this.overlay.alpha = 0;
        this.overlay.rect(-2000, -2000, 4000, 4000);
        this.overlay.fill({ color: 0x000000 });
        this.overlay.zIndex = MOVE_Z_INDEX - 1;
        card.container.parent.addChild(this.overlay);
        gsap.to(this.overlay, {
            alpha: 0.5,
            duration: 0.9,
            ease: Power1.easeInOut,
            repeatDelay: 1.5,
            yoyo: true,
            repeat: 1,
        }).then(() => {
            this.overlay.removeFromParent();
            this.overlay.destroy();
        });
    }
}
